// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"f73fad5d","453":"2aa06aab","540":"26d4976c","646":"cdb97082"}[chunkId] + ".chunk.js";
};